import { FunctionComponent } from 'react';
import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { mapDynamicContentItems } from '../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';
import { WebLink } from '../../../app-kit/components/WebLink/types';
import { mapApiWeblinkIconInfoToLinkIconInfo } from '../../../app-kit/helpers/mapApiWeblinkIconInfoToLinkIconInfo';
import { mapApiWeblinkVariantToLinkVariant } from '../../../app-kit/helpers/mapApiWeblinkVariantToLinkVariant';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { MieleBanner } from './MieleBanner';

interface MieleBannerWithDataProps {
  showContentBrick?: boolean;
}

export const MieleBannerWithData: FunctionComponent<MieleBannerWithDataProps> = ({
  showContentBrick = false,
}) => {
  const mieleBanner =
    usePropertyPageQuery()?.data.propertyPageBySlugV3.mediaPartnerBanners?.mieleBanner;
  if (!mieleBanner) return null;

  const { text, ctaLink, context } = mieleBanner;

  const mappedLink: WebLink = {
    ...ctaLink,
    variant: mapApiWeblinkVariantToLinkVariant(ctaLink.variant),
    iconInfo: ctaLink.iconInfo ? mapApiWeblinkIconInfoToLinkIconInfo(ctaLink.iconInfo) : null,
  };

  return showContentBrick ? (
    <ContentBrick>
      <MieleBanner link={mappedLink} text={mapDynamicContentItems(text)} context={context} />
    </ContentBrick>
  ) : (
    <MieleBanner link={mappedLink} text={mapDynamicContentItems(text)} context={context} />
  );
};
